import React, { MouseEventHandler } from 'react';
import Link from 'next/link';
import { ParsedUrlQuery } from 'querystring';
import { TripTypes } from '@model/common';
import { TestId } from '@components/test-ids';
import { PlainLinkStyles } from '@styles/common';
import { getTourProductUrl } from '@util/tours';

export interface TourProductLinkProps {
  path: string;
  children?: JSX.Element | string;
  tripType: TripTypes;
  query?: ParsedUrlQuery;
  onClick?: MouseEventHandler;
}

export const TourProductLink = ({ path, query, children, tripType, onClick }: TourProductLinkProps) => {
  const link = getTourProductUrl({ ...query, productPath: path, tripType });

  return path ? (
    <Link prefetch={false} {...link} passHref css={PlainLinkStyles} onClick={onClick} data-testid={TestId.tourLink}>
      {children}
    </Link>
  ) : (
    <>{children}</>
  );
};
